export default {
  descricao: '',
  tempo_estimado: 0
}